import AboutUs from 'components/AboutUs';
import React from 'react';
import { Helmet } from 'react-helmet';

const AboutUsPage = () => {
  return (
    <div>
      <Helmet>
        <title>About Us</title>
      </Helmet>
      <AboutUs />
    </div>
  );
};

export default AboutUsPage;
